import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/map/216022/logo1.png';
import _imports_1 from '@/assets/map/216022/appindex.png';
const _hoisted_1 = {
  class: "mapcontainer",
  id: "mapcontainer"
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mprompt = _resolveComponent("mprompt");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(_component_mprompt, {
    onClick: _cache[0] || (_cache[0] = $event => $data.promptboxFlag = false)
  }, null, 512), [[_vShow, $data.promptboxFlag]]), _createElementVNode("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "logo"
  }, [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1)), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.areaList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.goDetail(item, index)
    }, null, 8, _hoisted_2);
  }), 128)), _cache[1] || (_cache[1] = _createElementVNode("img", {
    class: "bgimg",
    src: _imports_1,
    alt: ""
  }, null, -1))])])], 64);
}